
import {
  Column,
  ColumnChooser,
  ColumnDirective,
  ColumnMenu,
  ColumnsDirective,
  Edit,
  EditSettingsModel,
  ExcelExport,
  Filter,
  FilterSettingsModel,
  GridComponent,
  Group,
  Inject,
  Page,
  PageSettingsModel,
  Resize,
  Toolbar,
} from '@syncfusion/ej2-react-grids';
import { Component } from 'react';

interface IState {
  elementAliasData:Array<any>
}
interface IProps {}

export class EventMaterialType extends Component<IProps,IState> {
  private gridMaterialTypeObj: any;
  constructor(prop: IProps) {
    super(prop);
    this.state = {
      elementAliasData:[]
    };
  }
  public validationRule: Object = { required: true };

  public FilterOptions: FilterSettingsModel = { type: 'Menu' };
  public toolbarOptions = [
    "Add",
    "Edit",
    "Delete",
    "Update",
    "Cancel",
     {
       text: 'Refresh',
       tooltipText: 'Refresh',
       prefixIcon: 'e-refresh',
       id: 'refresh',
     },
     'ColumnChooser',
     'ExcelExport',
     'Search',
 
   ];
   public editOptions: EditSettingsModel = {
    allowAdding: true,
    allowDeleting: true,
    allowEditing: true,
  };
  public pageOptions: PageSettingsModel = {
    currentPage: 1,
    pageSize: 12,
    pageCount: 8,
    pageSizes: true,
  };
  toolbarClick(args: any) {
    if(args.item.id==='refresh'){
     // this.get();
    }
    if (this.gridMaterialTypeObj && args.item.id === 'gridMaterialType_excelexport') {
      this.gridMaterialTypeObj.excelExport();
    }
  }
  deleteElementAlias() {
    throw new Error('Method not implemented.');
  }
  editElementAlias() {
    throw new Error('Method not implemented.');
  }
  addElementAlias() {
    throw new Error('Method not implemented.');
  }
  actionBeginEventType(args: any) {
    if (args.action === 'add') {
     // this.SavePointAdd(args.data);
    } else if (args.action === 'edit') {
    //  this.SavePointEdit(args.data);
    } else if (args.requestType === 'delete') {
    //  this.deletePoint(args.data);
    }
  }
  render() {
    return (
      <div>
        <GridComponent
          id='gridMaterialType'
          editSettings={this.editOptions}
          toolbar={this.toolbarOptions}
          dataSource={this.state.elementAliasData}
          height='calc(-220px + 100vh)'
          ref={(g) => (this.gridMaterialTypeObj = g)}
          filterSettings={this.FilterOptions}
          allowFiltering={true}
          allowPaging={true}
          pageSettings={this.pageOptions}
          showColumnMenu={true}
          allowResizing={true}
          allowGrouping={true}
          showColumnChooser
          allowExcelExport={true}
          toolbarClick={this.toolbarClick.bind(this)}
          actionBegin={this.actionBeginEventType.bind(this)}
          gridLines='Both'
        >
          <ColumnsDirective>
            <ColumnDirective
              field='typeCode'
              headerText='Event Material Type Code'
              textAlign='Left'
              validationRules={this.validationRule}

            />
            <ColumnDirective
              field='typeDescription'
              headerText='Element Material Type Description'
              textAlign='Left'
              validationRules={this.validationRule}

            />
            <ColumnDirective
              field='Type_Description'
              headerText='Element Material Type Alias'
              textAlign='Left'
              validationRules={this.validationRule}

            />
          </ColumnsDirective>
          <Inject services={[Edit, Toolbar, Filter, Page,ColumnChooser,
              ExcelExport, ColumnMenu, Resize,Group]} />
        </GridComponent>
      </div>
    );
  }
}

export default EventMaterialType;

